// Module
var code = "<div class=\"main__content\"> <div class=\"main__content__header\"> <header class=\"header\"></header> </div> </div> <template id=\"section-template\"> <section></section> </template> ";
// Exports
export default code;